import React from "react";
import { NavLink } from "react-router-dom";

const FinalCTA = () => {
    
    return (
        <>
            {/* CTA */}
            <section className="about-cta" style={{
                background:
                    "linear-gradient(170deg,#fff 0%,#fff7f7 40%,#fff 100%)"
            }}>

                <div className="cta-box">

                    <span className="section-tag">
                        LET’S BUILD TOGETHER
                    </span>

                    <h2 style={{ textAlign: "center", }}>
                        Have An App Idea?
                    </h2>

                    <p style={{ textAlign: "center", }}>
                        Let’s transform your vision into a powerful mobile app experience.
                    </p>
                    <NavLink to="/Contactus">
                        <button className="primary-btn">
                            Book Free Consultation
                        </button>
                    </NavLink>
                </div>

            </section>

        </>
    );
};

export default FinalCTA;